import { useDialog } from '@globals/dialog/useDialogStore'
import { DIALOG_KEY } from '@layouts/standardPageLayout'
import LaunchIcon from '@mui/icons-material/Launch'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { T } from '@transifex/react'

type SupportButtonProps = {
  helpUrl?: string
  routeElementId?: string
}

const SupportButton: React.FC<SupportButtonProps> = ({ helpUrl, routeElementId }) => {
  const { openDialog: openHelpDialog } = useDialog(`${routeElementId}${DIALOG_KEY}`)

  return (
    <Stack
      sx={{
        alignItems: 'flex-start',
      }}>
      <Typography variant="body1" sx={{ mt: 2, color: 'text.secondary' }}>
        <T _str="Need more help?" />
      </Typography>
      {!!routeElementId && (
        <Button id="btnOpenHelpDrawer" variant="text" onClick={openHelpDialog}>
          <T _str="Open help drawer" />
        </Button>
      )}
      <Button
        id="btnSupportArticles"
        variant="text"
        href={helpUrl || '#'}
        target="_blank"
        rel="noopener noreferrer"
        endIcon={<LaunchIcon />}>
        <T _str="View support articles" />
      </Button>
    </Stack>
  )
}

export default SupportButton
